import { useNodeTree, useNodeTreeState } from "@darksnow-ui/node-tree-headless";
import { memo, useMemo } from "react";
import { clsx } from "clsx";

interface NodeWrapperProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}

export const NodeWrapper = memo(
  ({ id, children, className }: NodeWrapperProps) => {
    const { handlers } = useNodeTree();

    // Get ALL necessary handlers from the system
    const wrapperProps = useMemo(
      () => handlers.wrapperProps(id),
      [handlers, id],
    );

    // Get visual states
    const isSelected = useNodeTreeState((s) => s.selectedNodes.has(id));
    const isFocused = useNodeTreeState((s) => s.focusId === id);
    const isCursor = useNodeTreeState((s) => s.cursorId === id);
    const isDragOver = useNodeTreeState((s) => s.dragOverId === id);
    const isDragging = useNodeTreeState((s) => s.dragStartId === id);

    return (
      <div
        {...wrapperProps}
        data-node-id={id}
        className={clsx(
          "node-wrapper",
          className,
          isSelected && "selected",
          isFocused && "focused",
          isCursor && "cursor",
          isDragOver && "drag-over",
          isDragging && "dragging",
        )}
      >
        {children}
      </div>
    );
  },
);

NodeWrapper.displayName = "NodeWrapper";
